import { Route, Routes } from 'react-router-dom'
import { Sidebar } from '../../components/sidebar'
import Home from './Home'
import UserManagement from './UserManagement'
import EndUserManagement from './EndUserManagement'
import MasterSettings from './MasterSettings'
import Settings from './Settings'
import WidgetManagement from './WidgetManagement'
import { useAuth } from '../../context/authContext'
import { Unauthorized } from '../Unauthorized'
import { RouteElement } from '../../interfaces/_common'
import { HomeIcon, UserIcon, UserGroupIcon, UserCircleIcon, Squares2X2Icon, WrenchScrewdriverIcon, AdjustmentsHorizontalIcon, VideoCameraIcon, FilmIcon, GlobeAltIcon, Cog6ToothIcon, Cog8ToothIcon, CurrencyDollarIcon, CreditCardIcon, UserPlusIcon, BookmarkIcon, DocumentIcon, ListBulletIcon, ChartBarIcon, ArchiveBoxIcon, ArrowPathIcon, CpuChipIcon, DocumentTextIcon, SparklesIcon, QuestionMarkCircleIcon, IdentificationIcon, BookOpenIcon, RectangleGroupIcon, RectangleStackIcon, StarIcon, ShieldCheckIcon, ArrowTrendingUpIcon, QueueListIcon, ExclamationCircleIcon, CheckBadgeIcon, SignalIcon } from '@heroicons/react/24/outline'
import RouteKeys from '../../constants/route-keys'
import ShowManagment from './ShowManag'
import Episodes from './Episodes'
import Collections from './Collections'
import Category from './Category'
import { hasAccess } from '../../constants/permission.utils';
import MonetizationConfiguration from './MonetizationConfiguration'
import IconMasterPage from './IconMaster'
import Reports from './Reports'
import SearchCapsules from './SearchCapsules'
import CachePurge from './CachePurge'
import PersonalizationResults from './PersonalizationResults'
import Logger from './Logger'
import CustomCheckout from './CustomCheckout'
import Articles from './Articles'

export const _routes: RouteElement[] = [
    {
        title: 'Home',
        route: '/',
        key: RouteKeys.HOME,
        component: Home,
        end: true,
        display: true,
        icon: HomeIcon
    },
    {
        title: 'Admin Users',
        route: '/user-management',
        key: RouteKeys.ADMIN_USER,
        display: true,
        hasChild: true,
        component: UserManagement,
        icon: UserIcon,
        children: [
            {
                key: RouteKeys.ADMIN_USER,
                title: 'User Management',
                route: '/user-management/users',
                icon: UserIcon,
            },
            {
                key: RouteKeys.ROLE,
                title: 'Role Management',
                route: '/user-management/roles',
                icon: IdentificationIcon,
            },
        ],
    },
    {
        title: 'OTT Users',
        route: '/ott-user-management',
        key: RouteKeys.USER,
        display: true,
        hasChild: true,
        component: EndUserManagement,
        icon: UserGroupIcon
    },
    {
        title: 'Settings',
        route: '/settings',
        key: RouteKeys.SETTINGS,
        display: true,
        hasChild: true,
        component: Settings,
        icon: Cog6ToothIcon,
        children: [
            {
                key: RouteKeys.GENERAL,
                title: 'General',
                route: '/settings/general-settings',
                icon: Cog8ToothIcon,
            },
            {
                key: RouteKeys.ONBOARDING_QUESTION_SETTINGS,
                title: 'Onboarding',
                route: '/settings/onboarding-settings',
                icon: UserPlusIcon,
            },
            {
                key: RouteKeys.PAYMENT_GATEWAY,
                title: 'Payment Gateway',
                route: '/settings/payment-settings',
                icon: CreditCardIcon,
            },
            {
                key: RouteKeys.RESOURCE_SETTING,
                title: 'Resource Settings',
                route: '/settings/resource-settings',
                icon: DocumentIcon,
            },
            // {
            //     key: RouteKeys.HELP_SUPPORT_SETTINGS,
            //     title: 'Help & Support Settings',
            //     route: '/settings/help-support-settings',
            // },
            {
                key: RouteKeys.AI_SETTINGS,
                title: 'AI Settings',
                route: '/settings/ai-settings',
                icon: SparklesIcon,
            },
            {
                key: RouteKeys.BOOKMARK_SETTINGS,
                title: 'Bookmark Settings',
                route: '/settings/bookmark-settings',
                icon: BookmarkIcon,
            },
            {
                key: RouteKeys.PILLBANNER_SETTINGS,
                title: 'Pill Banner Settings',
                route: '/settings/pill-banner-settings',
                icon: DocumentIcon,
            },
            {
                key: RouteKeys.ONBOARDING,
                title: 'Onboarding Questions',
                route: '/settings/onboarding-question-settings',
                icon: QuestionMarkCircleIcon,
            },
            {
                key: RouteKeys.HTML_UPLOAD_SETTINGS,
                title: 'HTML Upload Settings',
                route: '/settings/html-upload-settings',
                icon: DocumentTextIcon,
            },

        ],
    },
    {
        title: 'Plan',
        route: '/plan',
        key: RouteKeys.PLAN,
        display: true,
        hasChild: true,
        component: MonetizationConfiguration,
        icon: CurrencyDollarIcon,
    },
    {
        title: 'Icons Master',
        route: '/icons',
        key: RouteKeys.ICONS,
        display: true,
        hasChild: true,
        component: IconMasterPage,
        icon: ListBulletIcon,
    },
    {
        title: 'Master',
        route: '/master',
        key: RouteKeys.MASTER,
        display: true,
        hasChild: true,
        component: MasterSettings,
        icon: WrenchScrewdriverIcon,
        children: [
            {
                key: RouteKeys.LANGUAGE,
                title: 'Language Master',
                route: '/master/language-master',
                icon: BookOpenIcon,
            },
            {
                key: RouteKeys.WIDGET,
                title: 'Widget Master',
                route: '/master/widget-master',
                icon: RectangleGroupIcon,
            },
            {
                key: RouteKeys.TEMPLATE_MASTER,
                title: 'Template Master',
                route: '/master/template-master',
                icon: RectangleGroupIcon,
            },
            {
                key: RouteKeys.TOOLS,
                title: 'Tools Master',
                route: '/master/tools-master',
                icon: WrenchScrewdriverIcon,
            },
            {
                key: RouteKeys.APP_VERSION,
                title: 'App Version Master',
                route: '/master/app-version-master',
                icon: ArrowPathIcon,
            }
        ],
    },
    {
        title: 'Template',
        route: '/template',
        key: RouteKeys.TEMPLATE,
        display: true,
        hasChild: true,
        component: WidgetManagement,
        icon: AdjustmentsHorizontalIcon,
        children: [
            {
                key: RouteKeys.TEMPLATE,
                title: 'Template Management',
                route: '/template/template-management',
                icon: RectangleStackIcon,
            },
        ],
    },
    // {
    //     title: 'Resource',
    //     route: '/resource',
    //     key: RouteKeys.RESOURCE,
    //     display: true,
    //     hasChild: true,
    //     component: ResourceManagment,
    //     icon: RectangleStackIcon,
    // },
    {
        title: 'Category',
        route: '/category',
        key: RouteKeys.CATEGORY,
        display: true,
        hasChild: true,
        component: Category,
        icon: Squares2X2Icon,
    },
    {
        title: 'Collection',
        route: '/collections',
        key: RouteKeys.COLLECTION,
        display: true,
        hasChild: true,
        component: Collections,
        icon: FilmIcon,
    },
    {
        title: 'Show',
        route: '/show',
        key: RouteKeys.SHOW,
        display: true,
        hasChild: true,
        component: ShowManagment,
        icon: GlobeAltIcon,
    },
    {
        title: 'Episode',
        route: '/episodes',
        key: RouteKeys.EPISODE,
        display: true,
        hasChild: true,
        component: Episodes,
        icon: VideoCameraIcon,
    },
    {
        title: 'Article',
        route: '/articles',
        key: RouteKeys.ARTICLE,
        display: true,
        hasChild: true,
        component: Articles,
        icon: DocumentTextIcon,
    },
    {
        title: 'Payment Method',
        route: '/checkout',
        key: RouteKeys.CUSTOM_CHECKOUT,
        display: true,
        hasChild: true,
        component: CustomCheckout,
        icon: CheckBadgeIcon,
          children: [
            {
                key: RouteKeys.CUSTOM_CHECKOUT,
                title: 'Payment Method',
                route: '/checkout/payment-method',
                icon: ShieldCheckIcon,
            },
            {
                key: RouteKeys.CUSTOM_CHECKOUT,
                title: 'Payment Error',
                route: '/checkout/payment-error',
                icon: ExclamationCircleIcon,
            }]
    },
    {
        title: 'Reports',
        route: '/reports',
        key: RouteKeys.REPORT,
        display: true,
        hasChild: true,
        component: Reports,
        icon: ChartBarIcon,
        children: [
            {
                key: RouteKeys.PAYMENT_ORDER_REPORT,
                title: 'Payment Order Report',
                route: '/reports/payment-order-report',
                icon: CurrencyDollarIcon,
            },
            {
                key: RouteKeys.DISLIKE_REPORT,
                title: 'Dislike Report',
                route: '/reports/dislike-report',
                icon: ChartBarIcon,
            },
            {
                key: RouteKeys.RATING_REPORT,
                title: 'Rating Report',
                route: '/reports/rating-report',
                icon: StarIcon,
            },
            {
                key: RouteKeys.USER_PLAN_REPORT,
                title: 'Payment Reconciliation',
                route: '/reports/payment-reconciliation',
                icon: UserCircleIcon,
            },
            {
                key: RouteKeys.ACQUISITION_REPORT,
                title: 'Acquisition Report',
                route: '/reports/acquisition-report'
            },
            {
                key: RouteKeys.ACQUISITION_FUNNEL_REPORT,
                title: 'Acquisition Funnel Report',
                route: '/reports/acquisition-funnel-report',
                icon: ChartBarIcon,
            },
            {
                key: RouteKeys.SUBSCRIPTION_REPORT,
                title: 'Subscription Report',
                route: '/reports/subscription-report',
                icon: ChartBarIcon,
            },
            {
                key: RouteKeys.SUBSCRIPTION_HEALTH_REPORT,
                title: 'Subscription Health',
                route: '/reports/subscription-health-report',
                icon: ShieldCheckIcon,
            },
            {
                key: RouteKeys.CONVERSION_FUNNEL_REPORT,
                title: 'Conversion Funnel',
                route: '/reports/conversion-funnel-report',
                icon: ArrowTrendingUpIcon,
            },
             {
                key: RouteKeys.REVENUE_MONETIZATION_REPORT,
                title: 'Revenue Monetization',
                route: '/reports/revenue-monetization-report',
                icon: CurrencyDollarIcon,
            },
            // {
            //     key: RouteKeys.ACQUISITION_REPORT,
            //     title: 'Acquisition Report',
            //     route: '/reports/acquisition-report',
            // },
            // {
            //     key: RouteKeys.CONVERSION_REPORT,
            //     title: 'Conversion Report',
            //     route: '/reports/conversion-report',
            // },
            // {
            //     key: RouteKeys.ENGAGEMENT_REPORT,
            //     title: 'Engagement Report',
            //     route: '/reports/engagement-report',
            // },
            // {
            //     key: RouteKeys.MONETIZATION_REPORT,
            //     title: 'Monetization Report',
            //     route: '/reports/monetization-report',
            // },
        ],
    },
     {
        title: 'Logger',
        route: '/logger',
        key: RouteKeys.LOGGER,
        display: true,
        hasChild: true,
        component: Logger,
        icon: DocumentTextIcon,
        children: [
            {
                key: RouteKeys.VIDEO_TRACKING_LOGGER,
                title: 'Video Tracking Logger',
                route: '/logger/video-tracking-logger',
                icon: DocumentTextIcon,
            },
            {
                key: RouteKeys.BUFFER_LOGS,
                title: 'Buffer Logs',
                route: '/logger/buffer-logs',
                icon: QueueListIcon,
            },
            {
                key: RouteKeys.PLAYER_ERROR_LOGS,
                title: 'Video Player Error Logs',
                route: '/logger/player-error-logs',
                icon: ExclamationCircleIcon,
            },
            {
                key: RouteKeys.WEBHOOK_INSTRUMENT,
                title: 'Webhook Instrument Log',
                route: '/logger/webhook-instrument',
                icon: SignalIcon,
            },
        ],
    },
    {
        title: 'Search Capsules',
        route: '/search-capsules',
        key: RouteKeys.SEARCH_CAPSULES,
        display: true,
        hasChild: true,
        component: SearchCapsules,
        icon: ArchiveBoxIcon,
        children: [
            {
                key: RouteKeys.SEARCH_CAPSULES,
                title: 'Search Capsule',
                route: '/search-capsules',
                icon: ArchiveBoxIcon,
            },
        ]
    },
    {
        title: 'Cache Purge',
        route: '/cache-purge',
        key: RouteKeys.CACHE_PURGE,
        display: true,
        hasChild: true,
        component: CachePurge,
        icon: ArrowPathIcon,
        children: [
            {
                key: RouteKeys.CACHE_PURGE,
                title: 'Cache Purge',
                route: '/cache-purge',
                icon: ArrowPathIcon,
            },
        ]
    },
    {
        title: 'Personalized Simulation',
        route: '/personalized-simulation',
        key: RouteKeys.PERSONALIZED_SIMULATION,
        display: true,
        hasChild: true,
        component: PersonalizationResults,
        icon: CpuChipIcon,
        children: [
            {
                key: RouteKeys.PERSONALIZED_SIMULATION,
                title: 'Personalized Simulation',
                route: '/personalized-simulation',
                icon: CpuChipIcon,
            },
        ]
    },
    // {
    //     title: 'Contest',
    //     route: '/contest',
    //     key: RouteKeys.CONTEST,
    //     display: true,
    //     hasChild: true,
    //     component: ContestManagement,
    //     icon: TrophyIcon,
    //     children: [
    //         {
    //             key: RouteKeys.REWARDS,
    //             title: 'Reward Management',
    //             route: '/contest/reward-management',
    //         },
    //         {
    //             key: RouteKeys.QUESTIONS,
    //             title: 'Question Management',
    //             route: '/contest/question-management',
    //         },
    //         {
    //             key: RouteKeys.CONTEST,
    //             title: 'Contest Management',
    //             route: '/contest/contest-management',
    //         },
    //     ],
    // },
]

export const ProtectedContainer = () => {
    const auth = useAuth()
    return (
        <>
            <Sidebar routes={_routes} />
            <div className='flex-col w-full min-w-0 flex-1'>

                <Routes>
                    {
                        _routes.map(route => (
                            hasAccess(route.key, auth?.user?.permissions) ? <Route key={route.key} path={`${route.route}${route.hasChild ? '/*' : ''}`} element={<route.component />} />
                                : <Route key={route.key} path={route.route} element={<Unauthorized />} ></Route>
                        ))
                    }
                    <Route
                        path="*"
                        element={<h1 className="text-9xl font-bold">Not found!</h1>}
                    />
                </Routes>
            </div>
        </>
    )
}
